import useAddOrEditVisitor from 'hooks/allVisitors/drawers/useAddOrEditVisitor';
import useTranslation from 'hooks/useTranslation/useTranslation';
import * as React from 'react';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import WizardModalTemplate, { WizardStep } from 'v2/components/WizardModal/WizardModalTemplate';
import RolesStep from './RolesStep';
import UserDetailsStep, { UserDetailsFormValues } from './UserDetailsStep';
import UserGroupsStep from './UserGroupsStep';

const AddUserWizard: React.FC = () => {
  const { translation } = useTranslation();
  const { showSnackbar } = useSnackbarContext();
  const {
    coContractors,
    coContractorsLoading,
    administratorsVisitorGroups,
    administratorsVisitorGroupsLoading,
    installersVisitorGroups,
    installersVisitorGroupsLoading,
    addOrEditVisitor
  } = useAddOrEditVisitor({
    translation,
    handleFetchError: (msg) => showSnackbar(msg, { severity: 'error' })
  });

  const [userDetails, setUserDetails] = React.useState<UserDetailsFormValues | null>(null);
  const [groupIds, setGroupIds] = React.useState<string[]>([]);

  const existingEmails = coContractors
    .flatMap((group) => group.members.map((member) => member.email))
    .filter((email): email is string => !!email);

  const steps: WizardStep[] = [
    { label: translation.user_details },
    { label: translation.user_group_s, description: translation.optional },
    { label: translation.roles, description: translation.optional }
  ];

  return (
    <WizardModalTemplate title={translation.add_user} steps={steps} id="add-user-wizard">
      <UserDetailsStep onProceed={setUserDetails} existingEmails={existingEmails} />
      <UserGroupsStep groups={coContractors} groupsLoading={coContractorsLoading} onProceed={setGroupIds} />
      <RolesStep
        userDetails={userDetails}
        groupIds={groupIds}
        addOrEditVisitor={addOrEditVisitor}
        administratorsVisitorGroups={administratorsVisitorGroups}
        installersVisitorGroups={installersVisitorGroups}
        rolesLoading={administratorsVisitorGroupsLoading || installersVisitorGroupsLoading}
      />
    </WizardModalTemplate>
  );
};

export default AddUserWizard;
